import { FaEdit, FaTrash } from "react-icons/fa";
import { deleteUserAddress } from "../../../services/addressApi/addressApi";
import { useState } from "react";
import { toast } from "react-toastify";

export default function AddressList({
  list = [],
  onEdit,
  onRefresh,
  onSelect,   // ✅ FIX: add this
}) {
  const [selectedId, setSelectedId] = useState(null);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;

    try {
      const res = await deleteUserAddress(id);
      toast.success(res?.message || "Deleted successfully");
      onRefresh && onRefresh();
    } catch (err) {
      toast.error("Delete failed");
    }
  };

  // ✅ SELECT ADDRESS
  const handleSelect = (item) => {
    setSelectedId(item.id);

    const fullAddress = [
      item.faltHousNumber,
      item.street,
      item.locality,
      item.pincode,
    ]
      .filter(Boolean)
      .join(", ");

    // save locally
    localStorage.setItem("selectedAddress", fullAddress);

    // send to parent safely
    if (typeof onSelect === "function") {
      onSelect(fullAddress, item);
    }

    // toast.success("Address selected successfully!");
  };

  return (
    <>
      {list.map((item) => (
        <div
          key={item.id}
          onClick={() => handleSelect(item)}
          className={`p-2 border rounded mb-2 shadow-sm cursor-pointer transition
            ${
              selectedId === item.id
                ? "border-red-500 bg-red-50"
                : "hover:bg-gray-50"
            }`}
        >
          <div className="d-flex justify-content-between">
            <b>{item.addressTitle}</b>

   <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
  <FaEdit
    className="text-success"
    style={{ cursor: "pointer" }}
    onClick={(e) => {
      e.stopPropagation();
      onEdit(item);
    }}
  />

  <FaTrash
    className="text-danger"
    style={{ cursor: "pointer" }}
    onClick={(e) => {
      e.stopPropagation();
      handleDelete(item.id);
    }}
  />
</div>
          </div>

          <p>
            {item.street}, {item.locality}, {item.pincode}
          </p>
        </div>
      ))}
    </>
  );
}